import React from 'react'
import { GrcTable, GrcTableBody, GrcTableCell, GrcTableContainer, GrcTableHead, GrcTableHeadRow, GrcTableRow } from '../../Common/ui/TableComponent'

import Tooltip from '@mui/material/Tooltip'

import { t } from 'i18next'

import ContentCircle from 'src/Common/ui/contentCircle'

import { TableCell } from '@mui/material'
import { Checkbox } from 'src/Common/ui/checkbox'
import { INFORMED_INDEX_RACI } from 'src/Entities/Governance'
import { cn, roleColor } from 'src/lib/utils'
import { typeBodyCompCondition } from 'src/Entities/TransferEntities'
export default function TransferBodyTable ({
    type,
    selectAll, handleSelectAll, sortFilter, sortFilterRaci, paginatedData, handleTypeClick, handleSelectChecked, transferTableSearchValue, filteredRegulationData
    , currentPage
    , rowsPerPage
}) {
    const queryParams = new URLSearchParams(location.search)

    const matrixParam = +queryParams.get('matrix')
    return (
        <>
            <GrcTableContainer>
                <GrcTable>
                    <GrcTableHead>
                        <GrcTableHeadRow>
                            <GrcTableCell className="col-sticky" sx={{ minWidth: '40px', left: 0, zIndex: 1 }}>
                                <div className='flex justify-between'>
                                    <Tooltip title="Select all" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}><div className='mr-1'>
                                        <Checkbox
                                            checked={selectAll}
                                            onCheckedChange={(event) => handleSelectAll(event)}
                                            borderColor='text-primary'
                                        />
                                    </div>
                                    </Tooltip>
                                </div>
                            </GrcTableCell>

                            <GrcTableCell className="col-sticky" sx={{ minWidth: '40px', left: 47, zIndex: 1 }}>
                                <Tooltip title="S.No" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            #
                                    {/* <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}></Tooltip> */}
                                </Tooltip>
                            </GrcTableCell>
                            <GrcTableCell className="col-sticky" sx={{ minWidth: '24rem', left: 92, zIndex: 2 }}>
                            Regulation
                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={() => sortFilter('regulationName')} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip>
                            </GrcTableCell>

                            <GrcTableCell className="col-sticky !flex" sx={{ minWidth: '100px', zIndex: 1 }}>
                            Category
                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={() => sortFilter('regulationCategoryName')} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip>
                            </GrcTableCell>
                            { matrixParam !== 2 && <GrcTableCell className="col-sticky" sx={{ minWidth: '100px', zIndex: 1 }}>
                            Accountable
                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={() => sortFilter('complianceTitle')} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' /></Tooltip>
                            </GrcTableCell>}

                            {matrixParam !== 3 && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>
                            Consulted
                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={() => sortFilterRaci(2)} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' />
                                </Tooltip>
                            </GrcTableCell>}
                            {matrixParam !== 4 && <GrcTableCell align='center' sx={{ minWidth: '180px' }}>
                            Informed
                                <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <img onClick={() => sortFilterRaci(3)} className='ml-2 inline w-3 cursor-pointer' src='/Common/Icon/sortIcon.svg' />
                                </Tooltip>
                            </GrcTableCell>}
                        </GrcTableHeadRow>
                    </GrcTableHead>
                    <GrcTableBody>
                        {filteredRegulationData?.filter(ele => ele.regulationName?.toLowerCase().includes(transferTableSearchValue))?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).length > 0
                            ? (filteredRegulationData?.filter(ele => ele.regulationName?.toLowerCase().includes(transferTableSearchValue))?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)?.map((item, indexx) =>
                                <GrcTableRow key={indexx}>
                                    <GrcTableCell className='sticky' sx={{ minWidth: '40px', left: 0, zIndex: 1 }}>
                                        <Checkbox
                                            checked={item?.checkbox}
                                            onCheckedChange={(event) => handleSelectChecked(item.id)}
                                            borderColor='text-primary'
                                        />
                                    </GrcTableCell>
                                    <GrcTableCell className="col-sticky-td" sx={{ minWidth: '40px', left: 47, zIndex: 1 }}>
                                        <div className='flex justify-between items-center'>
                                            { <ContentCircle className='min-h-6 min-w-6 bg-[hsl(var(--primary-thick-foreground))]' contentClassName={'text-primary'} content={(currentPage - 1) * rowsPerPage + indexx + 1}/>
                                            }
                                        </div>
                                    </GrcTableCell>
                                    <GrcTableCell className="col-sticky-td  cursor-pointer" sx={{ minWidth: '24rem', left: 92, zIndex: 2 }}>{item.regulationName}</GrcTableCell>
                                    <GrcTableCell >{item.regulationCategoryName}</GrcTableCell>
                                    {
                                        Array.from({ length: 4 }, () => null).map((ele, j) => {
                                            const data = item?.raciiMatrices?.find((element) => {
                                                return +element.raciId === j + 1
                                            })
                                            return (
                                                <>
                                                    {
                                                        j + 1 !== matrixParam && j + 1 !== 1 && <>{data
                                                            ? <GrcTableCell align='center' sx={{ minWidth: '180px' }}>
                                                                <div>
                                                                    {!data.user && data.department && data.role && j !== 3
                                                                        ? <div className='flex justify-center gap-1'><img src='/Common/Icon/DangerIcon.svg' />Vacant</div>
                                                                        : !data.user
                                                                            ? (
                                                                                <div className='text-muted'>-</div>
                                                                            )
                                                                            : null}
                                                                    <p className='regulation-cell-first !text-[16px] whitespace-nowrap'>{data?.user}</p>
                                                                    { !data.user && j === INFORMED_INDEX_RACI ? null : <p style={{ color: roleColor(data?.role) }} className={cn('regulation-cell-third', '!text-[12px] mt-1 whitespace-nowrap')}>{data?.role}</p> }
                                                                </div>
                                                            </GrcTableCell>
                                                            : <GrcTableCell align='center'>-</GrcTableCell>}</>
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </GrcTableRow>
                            ))
                            : transferTableSearchValue?.length > 0
                                ? <GrcTableRow>
                                    <TableCell colSpan={8} align='center'>{t('No Data Found')}</TableCell>
                                </GrcTableRow>
                                : <GrcTableRow>
                                    <TableCell colSpan={8} align='center'>{t(typeBodyCompCondition(type) ? 'No Data Found' : 'Select the dropdown to view governance against the respective department.')}</TableCell>
                                </GrcTableRow>
                        }
                    </GrcTableBody>

                </GrcTable>
            </GrcTableContainer>

        </>
    )
}
